export default __webpack_public_path__ + "static/media/starHalfChecked.220b76dd.svg";